export const site = {
  brand: 'Y.S.E Media',
  company: 'Y.S.E Holdings Ltd',
  email: 'support@yse-media.com',
  addressLines: ['84 Spyrou Kyprianou Avenue', '4004 Limassol, Cyprus'],
  address: '84 Spyrou Kyprianou Avenue, 4004 Limassol, Cyprus',
  mapUrl: 'https://www.google.com/maps/search/?api=1&query=84+Spyrou+Kyprianou+Avenue+4004+Limassol+Cyprus',
};

export const navLinks = [
  { label: 'Services', href: '/#services' },
  { label: 'About', href: '/#about' },
  { label: 'Approach', href: '/#approach' },
  { label: 'Contact', href: '/#contact' },
];
